import React from 'react';
import RowActions from '../components/RowActions';

export const createColumns = ({
  editingRowId,
  saving,
  onStartEdit,
  onCancelEdit,
  onSaveEdit,
  onDeleteClick,
}) => [
  {
    accessorKey: '_id',
    header: 'ID',
    enableEditing: false,
  },
  {
    accessorKey: 'keyword',
    header: 'Keyword',
    size: 300,
    enableEditing: true,
  },
  {
    accessorKey: 'created_at',
    header: 'Created At',
    size: 200,
    enableEditing: false,
    Cell: ({ cell }) => {
      const value = cell.getValue();
      if (!value) return '';
      return new Date(value).toLocaleString();
    },
  },
  {
    id: 'actions',
    header: 'Actions',
    size: 120,
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ row }) => {
      const isEditing = editingRowId === row.original._id;

      return (
        <RowActions
          isEditing={isEditing}
          saving={saving}
          onEdit={() => onStartEdit(row.original)}
          onDelete={() => onDeleteClick(row.original)}
          onSave={() => onSaveEdit(row.original._id)}
          onCancel={onCancelEdit}
        />
      );
    },
  },
];
